<template>
    <div class="layout-wrapper" :class="{'is--full-screen': isFullScreen || isGeotab, 'is--collapsed': !menuVisible}">
        <div class="left-panel" v-if="!isFullScreen">
            <side-bar></side-bar>
        </div>
        <div class="right-panel">
            <top-bar v-if="!isFullScreen && !isGeotab"></top-bar>
            <div class="main-container">
                <app-main></app-main>
            </div>
        </div>
    </div>
</template>


<script>
import { mapState } from 'vuex'
import { isInjectToGeoTab } from '@/utils'
export default {
    name: 'layout-index',
    computed: {
        ...mapState({
            menuVisible: state => state.settings.menuVisible
        }),
		isGeotab() {
			return isInjectToGeoTab()
		}
    },
    components: {
        AppMain: () => import('./components/AppMain.vue'),
        SideBar: () => import('./components/SideBar.vue'),
        TopBar: () => import('./components/TopBar.vue'),
    },
    watch: {
        '$route'(to) {
            this.isFullScreen = to.meta.fullScreen ? to.meta.fullScreen : false;
        }
    },
    data() {
        return {
            isFullScreen: false
        }
    },
    created() {
        this.isFullScreen = this.$route.meta.fullScreen ? this.$route.meta.fullScreen : false;
    }
}
</script>

<style lang="scss" scoped>
.layout-wrapper {
    display: flex;
    height: 100vh;
    overflow: hidden;

    &.is--collapsed {
        .left-panel {
            width: 0;
            overflow: hidden;
            min-width: auto;
        }
    }

    &.is--full-screen {
        .main-container {
            height: 100vh;
        }
    }
}
.left-panel {
    height: 100%;
    min-width: $--sidebar-width;
    width: $--sidebar-width;
    border-right: 1px solid $--background-color-dark;
    box-sizing: border-box;
    transition: 0.2s;
}
.right-panel {
    flex: 1;
    height: 100%;
    overflow: hidden;
}

.main-container {
    height: calc(100vh - $--topbar-height);
}
</style>


<style lang="scss">
    
</style>